import React, { createContext, useContext, useState } from 'react';

const PopoverContext = createContext(null);

export const PopoverProvider = ({ children }) => {
    const [activePopoverId, setActivePopoverId] = useState(null);

    const openPopover = (id) => {
        setActivePopoverId(id);
    };

    const closePopover = () => {
        setActivePopoverId(null);
    };

    const isPopoverOpen = (id) => activePopoverId === id;

    return (
        <PopoverContext.Provider value={{
            openPopover,
            closePopover,
            isPopoverOpen,
            activePopoverId
        }}>
            {children}
        </PopoverContext.Provider>
    );
};

export const usePopover = () => {
    const context = useContext(PopoverContext);
    if (!context) {
        throw new Error('usePopover must be used within a PopoverProvider');
    }
    return context;
};

export default PopoverProvider;
